import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SignatureCaptureComponent } from '../signature-capture.component';

@Component({
  selector: 'app-signature-capture-dialog',
  template: `
    <app-signature-capture
      [signableId]="id"
      [signableStage]="stage"
      [signableType]="type"
      (signatureSaved)="close(true)"
      [deliveryId]="deliveryId"
      (cancel)="close(false)"
    ></app-signature-capture>
  `,
  standalone: true,
  imports: [SignatureCaptureComponent]
})
export class SignatureCaptureDialogComponent {
  stage = null;
  id = null;
  type = null;
  deliveryId = null;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private dialogRef: MatDialogRef<SignatureCaptureDialogComponent>
  ) {
    this.type = data.type;
    this.stage = data.stage;
    this.id = data.id;
    this.deliveryId = data?.deliveryId;
  }

  close(result: boolean) {
    this.dialogRef.close(result);
  }
}
